/** Canonical backend base URLs (no trailing slash). */
export const STAGING_API_URL = 'https://mockcoach-staging-staging.up.railway.app';
export const PRODUCTION_API_URL = 'https://mockcoach-ai-production.up.railway.app';

/** Public site hostnames — API is co-hosted; always use same-origin in the browser. */
export const CANONICAL_PUBLIC_HOSTNAMES = new Set([
  'jobmockai.com',
  'www.jobmockai.com',
]);

/** Frontends that should call the staging API when REACT_APP_API_URL is unset. */
export const STAGING_HOSTNAMES = new Set([
  'mockcoach-staging.railway.app',
  'mockcoach-staging-staging.up.railway.app',
]);

/** Railway production hostnames (not the canonical public domain). */
export const PRODUCTION_HOSTNAMES = new Set([
  'mockcoach-ai-production.up.railway.app',
  'mockcoach-production.railway.app',
]);

export const LOCAL_API_URL = 'http://localhost:3001';

const isLocalHostname = (hostname) =>
  hostname === 'localhost' || hostname === '127.0.0.1';

/**
 * Resolve the backend API base URL.
 * @param {{ hostname?: string, origin?: string }} [options] - Optional overrides for tests.
 */
export const getApiUrl = (options = {}) => {
  const hostname =
    options.hostname ??
    (typeof window !== 'undefined' && window.location && window.location.hostname
      ? window.location.hostname
      : 'localhost');

  const origin =
    options.origin ??
    (typeof window !== 'undefined' && window.location && window.location.origin
      ? window.location.origin
      : null);

  if (isLocalHostname(hostname)) {
    return LOCAL_API_URL;
  }

  // jobmockai.com serves the API on the same host — prefer same-origin over any
  // build-time REACT_APP_API_URL (e.g. old bundles still pointing at *.railway.app).
  if (CANONICAL_PUBLIC_HOSTNAMES.has(hostname) && origin) {
    return origin.replace(/\/$/, '');
  }

  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace(/\/$/, '');
  }

  if (STAGING_HOSTNAMES.has(hostname)) {
    return STAGING_API_URL;
  }

  if (PRODUCTION_HOSTNAMES.has(hostname)) {
    return PRODUCTION_API_URL;
  }

  // Co-hosted SPA + API on an unlisted deploy hostname — avoid localhost on real devices.
  if (origin && !isLocalHostname(hostname)) {
    return origin.replace(/\/$/, '');
  }

  return LOCAL_API_URL;
};

export const API_URL = getApiUrl();
